import React from 'react';
import logo from "../img/logo.png";
import gift from "../img/gift_no_patch.png";
import account from "../img/icon_account.png";
import {Link} from "react-router-dom";
import {withTranslation} from "react-i18next";
import '../style/profile-menu.css';

let HeaderComponent = ({t, languages, currentLanguage, onLangSelect, onLogout, path}) => {
	let hrefLink = '#';
	return <nav className="navbar main-navbar">
		<Link to="/" id="logo">
			<img src={logo} alt="" className="logo-proximus"/>
		</Link>
		<div className="program-title">
			<img src={gift} alt="" className="icon-gift"/>
		</div>
		<div className="navbar-brand" id="profile-header" key={path+'-'+currentLanguage}>
			<div id="kc-locale">
				<div id="kc-locale-wrapper">
					<div className="kc-dropdown" id="kc-locale-dropdown">
						<img src={account} className="logo-proximus" alt="logo"/>
						<ul>
							{languages.sort((a, b) => (a > b) ? 1 : -1).map(lang => <li className="kc-dropdown-item" key={lang}>
								<a href={hrefLink} onClick={() => {onLangSelect(lang)}}>{t(lang)}</a>
							</li>)}
							<li className="kc-dropdown-item">
								<Link to="/faq">
									<span className="pxIcon">&#58882;</span> FAQ
								</Link>
							</li>
							<li className="kc-dropdown-item">
								<a href="mailto:proximussurprise@proximus.com"><span className="pxIcon">&#57446;</span> Contact</a>
							</li>
							<li className="kc-dropdown-item">
								<a href={hrefLink} onClick={onLogout}> {t('logout')}</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</nav>;
};

export default withTranslation() (HeaderComponent)